import React, { Component } from 'react';
import { connect } from 'react-redux';

//3 party Libs
import moment from 'moment';

//material ui components
import { Grid } from '@material-ui/core'

//Actions
import { getCommunityByIdAsync } from '../../actions/communityActions'
import { GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject } from '../../actions/activityAction';

import parse from 'html-react-parser';

export class SchedulerMonthView extends Component {
    constructor(props) {
        super();

        this.state = {
            monthName: undefined,
            yearName: undefined,
            startDateMonthCalendar: undefined,
            endDateMonthCalendar: undefined,
            referenceDate: new Date(),
            //Community
            communityLoaded: undefined,
            //stepCount
            stepCount: 0,
            //Activities
            Activities: undefined,
            maxNumberActivitiesPerDay: 8,
            //Styles
            Styles: {
                activityRowHeight: 1.4,
                cellHeight: 15,
                cellWidth: '14.2857%',
            },
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            //Window
            windowWidht: undefined,
            windowHeiht: undefined,
            //Weeks in calendar
            weeksInCalendar: 5,
            //Filter
            filterObj: undefined,
            daysNeddedForCategoryCodes: 1,
            daysNeddedForLocationCodes: 1,

        }
    };

    //Days of the Week
    Days = [
        {
            id: 0,
            name: 'SUNDAY',
            short: 'Sun',
        },
        {
            id: 1,
            name: 'MONDAY',
            short: 'Mon',
        },
        {
            id: 2,
            name: 'TUESDAY',
            short: 'Tue',
        },
        {
            id: 3,
            name: 'WEDNESDAY',
            short: 'Wed',
        },
        {
            id: 4,
            name: 'THURSDAY',
            short: 'Thu',
        },
        {
            id: 5,
            name: 'FRIDAY',
            short: 'Fri',
        },
        {
            id: 6,
            name: 'SATURDAY',
            short: 'Sat',
        },
    ]

    //Hour Activities
    Hours = [
        {
            text: '12:00 am',
            hour: 0,
            minutes: 0,
        },
        {
            text: '01:00 am',
            hour: 1,
            minutes: 0,
        },
        {
            text: '02:00 am',
            hour: 2,
            minutes: 0,
        },
        {
            text: '03:00 am',
            hour: 3,
            minutes: 0,
        },
        {
            text: '04:00 am',
            hour: 4,
            minutes: 0,
        },
        {
            text: '05:00 am',
            hour: 5,
            minutes: 0,
        },
        {
            text: '06:00 am',
            hour: 6,
            minutes: 0,
        },
        {
            text: '07:00 am',
            hour: 7,
            minutes: 0,
        },
        {
            text: '08:00 am',
            hour: 8,
            minutes: 0,
        },
        {
            text: '09:00 am',
            hour: 9,
            minutes: 0,
        },
        {
            text: '10:00 am',
            hour: 10,
            minutes: 0,
        },
        {
            text: '11:00 am',
            hour: 11,
            minutes: 0,
        },
        {
            text: '12:00 pm',
            hour: 12,
            minutes: 0,
        },
        {
            text: '01:00 pm',
            hour: 13,
            minutes: 0,
        },
        {
            text: '02:00 pm',
            hour: 14,
            minutes: 0,
        },
        {
            text: '03:00 pm',
            hour: 15,
            minutes: 0,
        },
        {
            text: '04:00 pm',
            hour: 16,
            minutes: 0,
        },
        {
            text: '05:00 pm',
            hour: 17,
            minutes: 0,
        },
        {
            text: '06:00 pm',
            hour: 18,
            minutes: 0,
        },
        {
            text: '07:00 pm',
            hour: 19,
            minutes: 0,
        },
        {
            text: '08:00 pm',
            hour: 20,
            minutes: 0,
        },
        {
            text: '09:00 pm',
            hour: 21,
            minutes: 0,
        },
        {
            text: '10:00 pm',
            hour: 22,
            minutes: 0,
        },
        {
            text: '11:00 pm',
            hour: 23,
            minutes: 0,
        },

    ]

    async componentDidMount() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (communityId) {

            // const start = this.state.startDateMonthCalendar ? new moment(this.state.startDateMonthCalendar).valueOf(): undefined;
            // const end = this.state.endDateMonthCalendar? new moment(this.state.endDateMonthCalendar).valueOf() : undefined;

            await this.props.GetCalendarActivities(communityId);
        }
        await this.GetStartAndEndofTheMonth();


        if (this.props && this.props.filterObj) {
            this.setState({ filterObj: this.props.filterObj });
        }

    }

    GetHTMLFromString = ({ str = undefined, styleObjString = undefined }) => {
        try {
            let newStr = str;
            if (styleObjString && styleObjString.length > 0) {
                newStr = this.ChangeStrStyle(str, styleObjString);
            }

            if (!newStr) return (<Grid item container></Grid>)

            return (
                <Grid item container>
                    {parse(newStr)}
                    {/* <Grid item container  dangerouslySetInnerHTML={{__html: str}}></Grid> */}
                    {/* <img style={{height:'7px', width:'7px'}}src='https://androidguias.com/wp-content/uploads/2022/02/spiderman-AB.jpg'/> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" style={{height:'7px', width:'7px'}} viewBox="0 0 448 512"><path d="M448 88v336c0 13.3-10.7 24-24 24h-24c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24zm-280.5 66.4l65.6 65.6H24c-13.3 0-24 10.7-24 24v24c0 13.3 10.7 24 24 24h209.1l-65.6 65.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L353.9 273c9.4-9.4 9.4-24.6 0-33.9L218.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9z" fill="blue"/></svg> */}
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }

    ChangeStrStyle = (str, styleObj) => {
        try {
            let strModified = str;
            const styleObjAsString = `<svg ${styleObj} `

            if (styleObj) {
                strModified = str.replace('<svg', styleObjAsString);
            }

            return strModified
        } catch (err) {
            return str;
        }
    }

    resize() {
        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }

        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    };

    async GetActivities() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        this.setState({ Activities: null })
        // const start = this.state.startDateMonthCalendar ? new moment(this.state.startDateMonthCalendar).valueOf(): undefined;
        // const end = this.state.endDateMonthCalendar? new moment(this.state.endDateMonthCalendar).valueOf() : undefined;

        let activities = await this.props.GetCalendarActivities(communityId);

        activities = this.props.activitiesData.map(item => ({
            ...item,
            date: new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
            endDate: new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
        }));//End map

        const startDate = this.state.startDateMonthCalendar ? this.state.startDateMonthCalendar.clone().startOf('day') : undefined;
        const endDate = this.state.endDateMonthCalendar ? this.state.endDateMonthCalendar.clone().endOf('day') : undefined;
        const monthActivities = activities.filter(activity => moment(activity.date) >= startDate && moment(activity.date) <= endDate)

        const currentMonthActivities = {
            currentMonthActivities: monthActivities,
            currentMonthActivitiesName: this.state.monthName,
        }

        let activityNamesToFilter = [...new Set(activities.map(item => item.title))];
        if (activityNamesToFilter) {
            activityNamesToFilter = activityNamesToFilter.map((item, index) => ({ id: index + 1, name: item }))
        }

        this.GetMaximunNumberOfActivitiesPerDay(startDate, endDate, monthActivities);

        this.setState({ AllActivities: activities, Activities: activities, currentMonthActivities: currentMonthActivities })
    };

    //GET Start and End of the Month
    GetStartAndEndofTheMonth = async () => {
        try {

            let startDateMonth = moment(this.state.referenceDate).startOf('month');
            let endDateMonth = moment(this.state.referenceDate).endOf('month');


            if (this.props.stepCount > 0) {
                startDateMonth = startDateMonth.add(this.props.stepCount, 'months');
                endDateMonth = endDateMonth.add(this.props.stepCount, 'months');

            } else if (this.props.stepCount < 0) {
                startDateMonth = startDateMonth.subtract(-1 * this.props.stepCount, 'months');
                endDateMonth = endDateMonth.subtract(-1 * this.props.stepCount, 'months');
            }

            startDateMonth.startOf('Month');
            endDateMonth.endOf('Month');

            const monthName = startDateMonth.format('MMMM');
            const yearName = startDateMonth.format('YYYY');

            let startDateMonthCalendar = startDateMonth.clone();
            let endDateMonthCalendar = startDateMonth.clone();

            if (startDateMonth.day() !== 0) {

                startDateMonthCalendar = startDateMonthCalendar.subtract(1, 'days').startOf('week');
            }
            endDateMonthCalendar = startDateMonthCalendar.clone().add(34, 'days').endOf('day')

            let weeksInCalendar = 5;

            if (endDateMonth > endDateMonthCalendar) {
                endDateMonthCalendar = endDateMonthCalendar.clone().add(1, 'week');
                weeksInCalendar = 6;
            }

            const KeysInfo = await this.GetKeysDates();

            const startDateCategoryCodes = (KeysInfo.startDateCategoryCodes) ? KeysInfo.startDateCategoryCodes : undefined;
            const endDateCategoryCodes = (KeysInfo.endDateCategoryCodes) ? KeysInfo.endDateCategoryCodes : undefined;
            const startDateLocationCodes = (KeysInfo.startDateLocationCodes) ? KeysInfo.startDateLocationCodes : undefined;
            const endDateLocationCodes = (KeysInfo.endDateLocationCodes) ? KeysInfo.endDateLocationCodes : undefined;
            const daysNeddedForCategoryCodes = (KeysInfo.daysNeddedForCategoryCodes) ? KeysInfo.daysNeddedForCategoryCodes : 1;
            const daysNeddedForLocationCodes = (KeysInfo.daysNeddedForLocationCodes) ? KeysInfo.daysNeddedForLocationCodes : 1;
            const categoriesUniqueArray = (KeysInfo.categoriesUniqueArray) ? KeysInfo.categoriesUniqueArray : undefined;
            const locationsUniqueArray = (KeysInfo.locationsUniqueArray) ? KeysInfo.locationsUniqueArray : undefined;

            this.setState({
                weeksInCalendar: weeksInCalendar,
                startDateMonthCalendar: (startDateMonthCalendar) ? startDateMonthCalendar : undefined,
                endDateMonthCalendar: (endDateMonthCalendar) ? endDateMonthCalendar : undefined,
                monthName: monthName,
                yearName: yearName,
                startDateCategoryCodes: startDateCategoryCodes,
                endDateCategoryCodes: endDateCategoryCodes,
                startDateLocationCodes: startDateLocationCodes,
                endDateLocationCodes: endDateLocationCodes,
                daysNeddedForCategoryCodes: daysNeddedForCategoryCodes,
                daysNeddedForLocationCodes: daysNeddedForLocationCodes,
                categoriesUniqueArray: categoriesUniqueArray,
                locationsUniqueArray: locationsUniqueArray,
            });


            return {
                startDateMonthCalendar,
                endDateMonthCalendar,
            }
        } catch (err) { }
    };

    GetKeysDates = async () => {
        try {
            //Calculate initial cell for category code cells
            let startOfCurrentMonth = new moment(this.state.referenceDate).clone().startOf('month')
            let endOfCurrentMonth = new moment(this.state.referenceDate).clone().endOf('month')

            if (this.props.stepCount > 0) {
                startOfCurrentMonth = startOfCurrentMonth.clone().add(this.props.stepCount, 'months');
                endOfCurrentMonth = endOfCurrentMonth.clone().add(this.props.stepCount, 'months');

            } else if (this.props.stepCount < 0) {
                startOfCurrentMonth = startOfCurrentMonth.clone().subtract(-1 * this.props.stepCount, 'months');
                endOfCurrentMonth = endOfCurrentMonth.clone().subtract(-1 * this.props.stepCount, 'months');
            }

            startOfCurrentMonth = startOfCurrentMonth.startOf('Month');
            endOfCurrentMonth = endOfCurrentMonth.endOf('Month');

            const startDayNumberOfMonth = startOfCurrentMonth.day();
            const endDayNumberOfMonth = endOfCurrentMonth.day();

            let startDateCategoryCodes = undefined;
            let endDateCategoryCodes = undefined;
            let startDateLocationCodes = undefined;
            let endDateLocationCodes = undefined;

            let categoriesArray = [];
            let locationsArray = [];

            let daysNeddedForCategoryCodes = 2;
            let daysNeddedForLocationCodes = 2;
            let activitiesData = this.props.activitiesData;
            activitiesData = activitiesData.filter(act => (new moment(act.date) >= startOfCurrentMonth && new moment(act.date) <= endOfCurrentMonth) ? true : false);


            if (activitiesData && activitiesData.length > 0) {

                let categoriesInfo = activitiesData.map(act => {
                    if (act && act.category) {
                        const category = act.category

                        return { name: category.name, iconUrl: category.iconUrl, categoryColor: category.categoryColor, categoryId: category.categoryId, }

                    } else {
                        return undefined;
                    }
                });

                categoriesInfo = categoriesInfo.filter(cat => (cat.name) ? 1 : -1);
                let uniqueCatArray = [...new Set(categoriesInfo.map(cat => (cat.name)))];

                let uniquecategoryObjArray = [];
                uniqueCatArray = uniqueCatArray.sort((a, b) => a.toUpperCase() > b.toUpperCase());

                for (let i = 0; i < uniqueCatArray.length; i++) {
                    const currentCatString = uniqueCatArray[i];
                    const categoryObj = categoriesInfo.find(cat => cat.name === currentCatString);

                    if (categoryObj) {
                        uniquecategoryObjArray.push(categoryObj);
                    }
                }

                // for(let i =0; i< uniquecategoryObjArray.length; i++){
                //     const currentCategorieObj = uniquecategoryObjArray[i];

                //     if(!currentCategorieObj || !currentCategorieObj.iconUrl || !currentCategorieObj.categoryColor || !currentCategorieObj.categoryId || !this.props.GetCategorieObject) continue

                //     const catIconSVGObject = await this.props.GetCategorieObject(currentCategorieObj.iconUrl, currentCategorieObj.categoryColor, currentCategorieObj.categoryId);

                //     currentCategorieObj.svgString = (catIconSVGObject)? catIconSVGObject : undefined;
                // }

                /////
                let urlObjArray = [];

                const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
                for (let i = 0; i < uniquecategoryObjArray.length; i++) {
                    if (!communityId) continue;

                    const currentCategorieObj = uniquecategoryObjArray[i];
                    const newUrlObj = {
                        communityId: communityId,
                        categoryId: currentCategorieObj.categoryId,
                        categoryColor: currentCategorieObj.categoryColor,
                        defaultIconUrl: currentCategorieObj.iconUrl,
                    }

                    urlObjArray.push(newUrlObj);
                }

                let newUrlsArray = undefined;
                if (urlObjArray && urlObjArray.length > 0) {
                    newUrlsArray = await this.props.GetMultipleCategorieObject(urlObjArray)
                }

                let newUrlsObjArray = [];
                if (newUrlsArray && newUrlsArray.length > 0) {
                    newUrlsObjArray = JSON.parse(newUrlsArray);
                }

                for (let i = 0; i < newUrlsObjArray.length; i++) {
                    const currentObj = newUrlsObjArray[i];


                    const uniqueCategory = uniquecategoryObjArray.find(cat => cat.categoryId === currentObj.categoryId && !cat.svgString);

                    if (uniqueCategory && currentObj.svgObject) {
                        uniqueCategory.svgString = currentObj.svgObject;
                    }
                }
                /////

                categoriesArray = uniquecategoryObjArray;

                daysNeddedForCategoryCodes = uniquecategoryObjArray.length <= 6 ? 1 : 2;

                let locationsInfo = activitiesData.map(act => act.location);

                let uniqueLocationArray = [...new Set(locationsInfo)];
                uniqueLocationArray = uniqueLocationArray.sort();

                let LocationObjArray = [];
                for (let i = 0; i < uniqueLocationArray.length; i++) {
                    let currentLocation = uniqueLocationArray[i];

                    let locationSplitArray = currentLocation.split(/[\s+]/);

                    //Starts with number
                    const regexNumber = new RegExp('^[0-9]+');

                    const res = regexNumber.test(locationSplitArray[0]);

                    let locationCode = undefined;

                    if (locationSplitArray[0] && locationSplitArray[0].length > 0 && res) {

                        let letterArray = locationSplitArray[0].split('');
                        letterArray = letterArray.filter(l => regexNumber.test(l)).join('');
                        locationCode = (letterArray && letterArray.length > 1) ? letterArray.slice(0, 2) : letterArray;

                    } else {
                        let locationFiltered = locationSplitArray.filter(l => (l !== '&' && l !== '&&') ? true : false)
                        locationFiltered = locationFiltered.map(l => l.slice(0, 1))

                        locationCode = (locationSplitArray && locationSplitArray.length === 1) ? locationFiltered[0] : locationFiltered[0] + locationFiltered[1]
                        const LocationObjFound = LocationObjArray.find(l => l.code.toUpperCase() === locationCode.toUpperCase());

                        if (LocationObjFound) {
                            let newCode = currentLocation.split('\\s+');
                            newCode = newCode.filter(l => (l !== '&' && l !== '&&'))

                            locationCode = newCode.map(w => {
                                let code = undefined;
                                if (w && w.length > 1) {
                                    code = w.slice(0, 2);
                                } else {
                                    code = w[0]
                                }

                                return code
                            }
                            ).join('').slice(0, 2);
                        }
                    }

                    const newLocation = {
                        code: locationCode.toUpperCase(),
                        name: currentLocation,
                    }
                    LocationObjArray.push(newLocation);
                }

                locationsArray = LocationObjArray;
                daysNeddedForLocationCodes = uniqueLocationArray.length <= 6 ? 1 : 2;
            }

            // if((startDayNumberOfMonth+1 ) > (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)){
            //     startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
            //     startDateLocationCodes = startOfCurrentMonth.clone().startOf('Week').add(daysNeddedForCategoryCodes,'d');
            // } else if((startDayNumberOfMonth + 1) > daysNeddedForCategoryCodes){
            //     startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
            //     startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract(daysNeddedForLocationCodes-1,'d');
            // }  else if(7- (endDayNumberOfMonth+ 1) >= (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)){
            //     startDateCategoryCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForCategoryCodes + (daysNeddedForLocationCodes -1)),'d');//
            //     startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForLocationCodes)-1,'d');
            // }else if(7 - (endDayNumberOfMonth+ 1) > daysNeddedForLocationCodes){
            //     startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract(daysNeddedForLocationCodes -1 ,'d');
            // }

            const spacesAtStart = startDayNumberOfMonth;
            const spacesAtEnd = (6 - (endDayNumberOfMonth));

            //New Dats For Keys
            if (spacesAtStart >= (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)) {
                if (daysNeddedForCategoryCodes === 2) {
                    endDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week').add(1, 'd');
                }

                if (daysNeddedForLocationCodes === 2) {
                    endDateLocationCodes = startOfCurrentMonth.clone().startOf('Week').add(daysNeddedForCategoryCodes + 1, 'd');
                }

                startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().startOf('Week').add(daysNeddedForCategoryCodes, 'd');
            } else if ((spacesAtStart >= daysNeddedForCategoryCodes) && (spacesAtStart <= (daysNeddedForCategoryCodes + 1))) {
                if (daysNeddedForCategoryCodes === 2) {
                    endDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week').add(1, 'd');
                }

                if (daysNeddedForLocationCodes === 2) {
                    endDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day');
                }

                startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract(daysNeddedForLocationCodes - 1, 'd');
            } else if ((spacesAtEnd) >= (daysNeddedForCategoryCodes + daysNeddedForLocationCodes)) {
                if (daysNeddedForCategoryCodes === 2) {
                    endDateCategoryCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((1 + (daysNeddedForLocationCodes - 1)), 'd');// 
                }

                if (daysNeddedForLocationCodes === 2) {
                    endDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day');
                }

                startDateCategoryCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForCategoryCodes + (daysNeddedForLocationCodes - 1)), 'd');//
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForLocationCodes) - 1, 'd');
            } else if (spacesAtStart >= (daysNeddedForCategoryCodes + 1)) {
                if (daysNeddedForCategoryCodes === 2) {
                    endDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week').add(1, 'd');
                }

                if (daysNeddedForLocationCodes === 2) {
                    endDateLocationCodes = endDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day');;
                }

                startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().startOf('Week').add(daysNeddedForCategoryCodes, 'd');
            } else if ((spacesAtEnd) >= (1)) {

                if (daysNeddedForCategoryCodes === 2) {
                    endDateCategoryCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((1 + (daysNeddedForLocationCodes - 1)), 'd');//
                }

                if (daysNeddedForLocationCodes === 2) {
                    endDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day');
                }

                startDateCategoryCodes = startDateCategoryCodes = startOfCurrentMonth.clone().startOf('Week');
                startDateLocationCodes = startOfCurrentMonth.clone().endOf('Month').endOf('Week').startOf('Day').subtract((daysNeddedForLocationCodes) - 1, 'd');
            }

            return {
                startDateCategoryCodes: startDateCategoryCodes,
                endDateCategoryCodes: endDateCategoryCodes,
                startDateLocationCodes: startDateLocationCodes,
                endDateLocationCodes: endDateLocationCodes,
                daysNeddedForCategoryCodes: daysNeddedForCategoryCodes,
                daysNeddedForLocationCodes: daysNeddedForLocationCodes,
                categoriesUniqueArray: categoriesArray,
                locationsUniqueArray: locationsArray,
            }
        } catch (err) { }
    }

    GetCategoryBadge(categoryName) {
        // (categoryName!=undefined)? categoryName: categoryName = 'Special event';
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&');

        const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

        return CategoryBadge;
    };

    GetCategoryIconComponent(cat) {
        return (
            <Grid item >
                <img
                    src={cat.iconUrl}
                    alt={cat.name}
                    style={{ height: '10px', width: '10px', backgroundColor: cat.categoryColor }}
                />
            </Grid>
        )
    }


    async GetActivityObject(locationActivityId, activity) {


        this.setState({ activitySelected: null })

        const activityObject = await this.props.GetActivityDetails(locationActivityId, localStorage.getItem('communityId'));

        const activityAnchorEl = document.getElementById('ActivityRowInCell' + locationActivityId);

        if (activityAnchorEl && activityObject) {

            this.props.OnActivityClick(activityObject, 'ActivityRowInCell' + locationActivityId);
        }
    };


    GetActivitiesSpecificDay = (startDate, endDate) => {

        let activities = undefined;

        if (this.state.Activities && this.state.Activities.length > 0) {
            activities = this.state.Activities.filter(item => (item.date >= startDate && item.date <= endDate))
        }

        if (this.state.maxNumberActivitiesPerDay && activities && activities.length > this.state.maxNumberActivitiesPerDay) {
            activities = activities.slice(0, this.state.maxNumberActivitiesPerDay);
        }

        return activities
    };


    //#region Method that gets the Height of the entire Cell depending on the number of the maximun activities 
    GetMaximunNumberOfActivitiesPerDay = (startDayInCalendar, endDayInCalendar, activitiesCurrentMonth) => {

        let maxNumberActivities = 10;

        let currentDay = startDayInCalendar;

        if (this.state.maxNumberActivitiesPerDay) {
            maxNumberActivities = this.state.maxNumberActivitiesPerDay;
        }
        else {
            while (currentDay <= endDayInCalendar) {


                const stratOfDay = currentDay.clone().startOf('day');
                const endOfDay = currentDay.clone().endOf('day');
                const activitiesInCurrentDay = activitiesCurrentMonth.filter(activity => moment(activity.date) >= stratOfDay && moment(activity.date) <= endOfDay).length;

                maxNumberActivities = activitiesInCurrentDay > maxNumberActivities ? activitiesInCurrentDay : maxNumberActivities;

                currentDay = currentDay.clone().add(1, 'days');
            }

        }



        const newCellHeight = (this.state.Styles.activityRowHeight * maxNumberActivities) + (this.state.Styles.activityRowHeight * 2)
        const StepLabelStyles = this.state.Styles;

        StepLabelStyles.cellHeight = newCellHeight;

        this.setState({ Styles: StepLabelStyles })


    };
    //#endregion


    filterActivities = (activities, filterObject) => {
        const completeMothActivities = [...activities];
        let newActivities = undefined;
        newActivities = completeMothActivities;

        if (filterObject) {
            //Activity Search
            if (filterObject.searchInput) {
                const regex = new RegExp(filterObject.searchInput.toLowerCase());
                newActivities = newActivities.filter(item => item.title.toLowerCase().match(regex));
            }

            //Activities Filter
            if (filterObject.activityFilter) {
                newActivities = newActivities.filter(item => item.title.trim() === filterObject.activityFilter.trim());
            }

            //Category Filter


            if (filterObject.categoryFilter) {

                newActivities = newActivities.filter(item => item.category.name.trim() === filterObject.categoryFilter.trim());
            }
        }

        this.setState({
            Activities: newActivities
        });
    };


    render() {
        if (this.props.updateIsNeeded) {
            this.GetActivities();
            this.props.setUpdateIsNeeded(false);
        }

        //Rows on the calendar
        const rows = this.state.weeksInCalendar === 5 ? [0, 1, 2, 3, 4] : [0, 1, 2, 3, 4, 5];

        //Gets allactivities andstore then in Activities state and currentMonthActivities for the act in current month
        if ((this.props.communitySelected !== this.state.communityLoaded) || this.state.Activities === undefined) {
            this.setState({ communityLoaded: this.props.communitySelected, Activities: undefined })
            this.GetActivities();
        }


        if (this.props.stepCount !== this.state.stepCount) {
            this.setState({ stepCount: this.props.stepCount })

            const values = this.GetStartAndEndofTheMonth();

            if (this.state.Activities && values) {

                const startDate = values.startDateMonthCalendar// this.state.startDateMonthCalendar? this.state.startDateMonthCalendar.clone().startOf('day') : undefined;
                const endDate = values.endDateMonthCalendar// this.state.endDateMonthCalendar? this.state.endDateMonthCalendar.clone().endOf('day'): undefined;
                const monthActivities = this.state.Activities.filter(activity => moment(activity.date) >= startDate && moment(activity.date) <= endDate)

                const currentMonthActivities = {
                    currentMonthActivities: monthActivities,
                    currentMonthActivitiesName: this.state.monthName,
                }

                this.GetMaximunNumberOfActivitiesPerDay(startDate, endDate, monthActivities);
                this.setState({ currentMonthActivities: currentMonthActivities })

            }


        }

        //Filter activities when the filterObj changes
        if (((this.props.filterObj !== this.state.filterObj)) && (this.state.Activities)) {
            this.setState({ filterObj: this.props.filterObj ? this.props.filterObj : {} });
            this.filterActivities(this.state.AllActivities, this.props.filterObj);
        }

        //#endregion

        //#region inside  Components
        const RenderRow = ({ rowNumber }) => {
            //Numbers of the days of the week
            const weekDays = [0, 1, 2, 3, 4, 5, 6];

            const rowClass = (rowNumber % 2 !== 0) ? 'oddRow' : 'evenRow'
            return (
                <Grid item container xs={12} className={rowClass}>
                    {
                        weekDays.map(
                            weekDay => {
                                return (
                                    <RenderCell
                                        key={'CellInCalendar' + weekDay}
                                        rowNumber={rowNumber}
                                        weekDay={weekDay}
                                    />
                                )
                            }
                        )
                    }
                </Grid>
            )
        };

        const RenderCell = ({ rowNumber, weekDay }) => {
            const today = new moment(new Date());
            const startDate = this.state.startDateMonthCalendar.clone().add(rowNumber, 'weeks').add(weekDay, 'days');
            const sameMonth = (this.state.startDateMonthCalendar.clone().add(rowNumber, 'weeks').add(weekDay, 'days').format('MMMM').toLowerCase() === this.state.monthName.toLowerCase())

            const sameDay = (today.format('YYYY/MM/DD') === startDate.format('YYYY/MM/DD'))

            const styles = {
                dayNumberStyles: {
                    color: sameMonth ? '#009EDD' : undefined,
                    fontWeight: 'bold',
                    fontSize: '12px',
                    paddingTop: (this.state.Styles.activityRowHeight / 4) + 'rem',
                },
                activityColumn: {
                    //paddingTop   : this.state.Styles.activityRowHeight+'rem',
                    paddingLeft: '1px',
                },
            };


            const dateOfStart = new Date(startDate.startOf('day'));
            const dateOfEnd = new Date(startDate.add(1, 'days').subtract(1, 'second'))

            const activities = this.GetActivitiesSpecificDay(dateOfStart, dateOfEnd);

            let classesCss = (this.state.weeksInCalendar && this.state.weeksInCalendar === 6) ? 'MonthViewCell MonthViewSixWCell' : 'MonthViewCell MonthViewFiveWCell';

            classesCss = sameDay ? classesCss + ' TodayCell ' : classesCss;
            return (
                <Grid item className={classesCss} container justify='center' alignItems='flex-start' >
                    {
                        (
                            startDate &&
                            (
                                (
                                    this.state.startDateCategoryCodes &&
                                    startDate.startOf('day').format('YYYYMMDD') === this.state.startDateCategoryCodes.clone().startOf('day').format('YYYYMMDD')
                                ) ||
                                (
                                    this.state.endDateCategoryCodes &&
                                    startDate.startOf('day').format('YYYYMMDD') === this.state.endDateCategoryCodes.clone().startOf('day').format('YYYYMMDD')
                                )
                            )
                        ) ?
                            <Grid item container>{getCategoriesColum(startDate, this.state.startDateCategoryCodes, this.state.daysNeddedForCategoryCodes)}</Grid>
                            :
                            (
                                // (startDate && this.state.startDateLocationCodes && startDate.startOf('day') >=  this.state.startDateLocationCodes.clone())   && (startDate.startOf('day')  <  this.state.startDateLocationCodes.clone().add(this.state.daysNeddedForLocationCodes, 'd') ) 
                                startDate &&
                                (
                                    (
                                        this.state.startDateLocationCodes &&
                                        startDate.startOf('day').format('YYYYMMDD') === this.state.startDateLocationCodes.clone().startOf('day').format('YYYYMMDD')
                                    ) ||
                                    (
                                        this.state.endDateLocationCodes &&
                                        startDate.startOf('day').format('YYYYMMDD') === this.state.endDateLocationCodes.clone().startOf('day').format('YYYYMMDD')
                                    )
                                )
                            ) ?
                                <Grid item container>{getLocationsColum(startDate, this.state.startDateLocationCodes, this.state.daysNeddedForCategoryCodes)}</Grid>
                                :
                                <Grid item container >
                                    <Grid item container xs={12} className='MonthViewActivitiesContainer' justify='center' alignItems='flex-start' style={sameDay ? { ...styles.activityColumn, } : { ...styles.activityColumn }}>
                                        {
                                            (sameMonth) ?
                                                <RenderActivitiesColumn date={startDate} activities={activities} startDate={startDate} rowNumber={rowNumber} weekDay={weekDay} sameMonth={sameMonth} />
                                                :
                                                undefined
                                        }
                                    </Grid>
                                </Grid>
                    }
                </Grid>
            );
        };

        const getCategoriesColum = (today, startDate, daysNedded) => {
            const categoriesArray = this.state.categoriesUniqueArray ? this.state.categoriesUniqueArray : [];

            const startItem = (today.format() === startDate.format()) ? 0 : 6;
            const endItem = (today.format() === startDate.format()) ? 6 : 12;

            const categoriesForToday = categoriesArray.slice(startItem, endItem);

            const sixWeeks = (this.state.weeksInCalendar && this.state.weeksInCalendar === 6) ? true : false;

            if (!categoriesForToday || (categoriesForToday && categoriesForToday.length === 0)) return <Grid item container ></Grid>
            return (
                <Grid item container justify='center' alignContent='flex-start' className='monthlyKeyCell' style={{ padding: '0px 10px' }}>
                    <Grid item container>
                        <Grid item container justify='center'>
                            <Grid item className={`engageBlue MonthViewKeyTitle ${sixWeeks ? 'MonthViewtitleSixWeeks' : undefined}`} >Category Key</Grid>
                        </Grid>
                        {
                            categoriesForToday.map(cat => {
                                const catName = (cat.name && cat.name.length < 20) ? cat.name : cat.name.slice(0, 17) + '...'
                                return (
                                    <Grid item container className={sixWeeks ? 'MonthViewKeyItem' : 'MonthViewKeyItemSixWeeks'}>
                                        <Grid item container xs={2} justify='center' alignContent='flex-start'>
                                            <Grid item container>
                                                {
                                                    (cat && cat.svgString) ?
                                                        <Grid item style={{ height: '9px', width: '9px' }}>
                                                            <this.GetHTMLFromString str={cat.svgString} styleObjString={"style='height: 9px; width: 9px;'"} />
                                                        </Grid>
                                                        :
                                                        undefined
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={10} alignContent='flex-end' justify='center'>
                                            <Grid item className={`MonthViewKeyName ${sixWeeks ? 'MonthViewKeyNameSixWeeks' : undefined}`} >
                                                {catName}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            }


                            )
                        }

                    </Grid>
                </Grid>
            )

        }

        const getLocationsColum = (today, startDate, daysNedded) => {
            const locationArray = this.state.locationsUniqueArray ? this.state.locationsUniqueArray : [];

            const startItem = (today.format() === startDate.format()) ? 0 : 6;
            const endItem = (today.format() === startDate.format()) ? 6 : 12;

            const locationForToday = locationArray.slice(startItem, endItem);

            if (!locationForToday || (locationForToday && locationForToday.length === 0)) return <Grid item container ></Grid>

            const sixWeeks = (this.state.weeksInCalendar && this.state.weeksInCalendar === 6) ? true : false;

            return (
                <Grid item container className='monthlyKeyCell' justify='center' alignContent='flex-start' style={{ padding: '0px 10px' }}>
                    <Grid item container>
                        <Grid item container justify='center'>
                            <Grid item className={`engageBlue MonthViewKeyTitle ${sixWeeks ? 'MonthViewKeyTitleSixWeeks' : undefined}`} >Location Key</Grid>
                        </Grid>
                        {
                            locationForToday.map(location => {
                                const locationName = (location && location.name && location.name.length < 25) ? location.name : location.name.slice(0, 22) + '...'
                                return (
                                    <Grid item container className={`${sixWeeks ? 'MonthViewKeyItemSixWeeks' : 'MonthViewKeyItem'} `} alignContent='flex-start'>
                                        <Grid item container xs={4} justify='center' alignContent='flex-start'>
                                            <Grid item className={sixWeeks ? 'MonthViewLocationCodeSixWeeks' : 'MonthViewLocationCode'}>
                                                {location.code}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={8} className={`${sixWeeks ? 'MonthViewKeyNameSixWeeks' : 'MonthViewKeyName'}`} alignContent='flex-start' justify='center' >
                                            <Grid item >
                                                {locationName}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            }


                            )
                        }

                    </Grid>
                </Grid>
            )
        }

        const RenderActivitiesColumn = ({ date, activities, rowNumber = undefined, weekDay = undefined, sameMonth = undefined }) => {

            const newActivities = (activities && activities.length > 6) ? activities.slice(0, 6) : activities;

            return (
                (newActivities && newActivities.length > 0) ?
                    newActivities.map((activity, index) => {

                        activity.category = (!activity.category) ? {
                            name: 'Special Events',
                            categoryColor: '#128055',
                            iconUrl: "https://engage360.s3.amazonaws.com/Icons/Categories/sparkles.svg"
                        } : activity.category

                        let locationKey = (activity && activity.location && this.state.locationsUniqueArray && this.state.locationsUniqueArray.length > 0) ? this.state.locationsUniqueArray.find(l => l.name.toLowerCase() === activity.location.toLowerCase()) : undefined;
                        locationKey = (locationKey && locationKey.code) ? locationKey.code : undefined

                        let length = (index === 0) ? 22 : 25;
                        let activityTitle = (activity.title) ? activity.title.trim() : ''
                        activityTitle = (activityTitle) ? (activityTitle.length <= length) ? activityTitle : activityTitle.substring(0, length - 3).trim() + `...` : '';
                        activityTitle = activityTitle + ` (${locationKey})`


                        const isSpecialEvents = (activity && activity.category && activity.category.name && (activity.category.name.toLowerCase() === 'special events' || activity.category.name.toLowerCase() === 'special event')) ? true : false;

                        const catFound = (this.state.categoriesUniqueArray) ? this.state.categoriesUniqueArray.find(cat => cat.name === activity.category.name) : undefined;

                        const titleWidth = (index === 0) ? '52%' : '70%';

                        const sixWeeks = (this.state.weeksInCalendar && this.state.weeksInCalendar === 6) ? true : false;
                        return (
                            <Grid item container xs={12} className='activityGrid' justify='center' alignContent='flex-end' style={{ paddingTop: '2px' }} onClick={() => this.GetActivityObject(activity._id, activity)} id={'ActivityRowInCell' + activity._id} key={'ActivityRowInCell' + activity._id}>
                                {/* <Grid item container xs={12} alignContent='flex-end'> */}
                                <Grid item container xs={12} className={`MonthViewActivityRow ${sixWeeks ? 'MonthViewActivityRowSixWeeks' : undefined}`} justify='flex-end' alignContent='center'>
                                    <Grid item container justify='flex-end' alignContent='flex-start' className={ isSpecialEvents ?  'MonthviewActivityTime activityTitleScheduleSpecialEvent' : 'MonthviewActivityTime'} style={{  width: '19%' }}>
                                        <Grid item >{moment(activity.date).format('h:mm')}</Grid>
                                    </Grid>

                                    <Grid item container style={{ width: '11%' }} justify='center' alignContent='flex-start'  >
                                        {
                                            (catFound && catFound.svgString) ?
                                                <Grid item style={sixWeeks ? { height: '7px', width: '7px' } : { height: '9px', width: '9px' }}>
                                                    <this.GetHTMLFromString str={catFound.svgString} styleObjString={sixWeeks ? "style='height: 7px; width: 7px;'" : "style='height: 9px; width: 9px;'"} />
                                                </Grid>
                                                :
                                                undefined
                                        }
                                    </Grid>

                                    <Grid item container style={{ width: titleWidth }} justify='flex-start' alignContent='flex-start'>
                                        <Grid item className={isSpecialEvents ? 'activityTitleSchedule activityTitleScheduleSpecialEvent': 'activityTitleSchedule' } justify='flex-start'>
                                            {activityTitle}
                                        </Grid>
                                    </Grid>

                                    {
                                        (titleWidth && titleWidth === '52%') ?
                                            <Grid item container xs={2} justify='center' alignContent='flex-start' >
                                                <Grid item className='MonthViewDayNumber'  >
                                                    {sameMonth ? this.state.startDateMonthCalendar.clone().add(rowNumber, 'weeks').add(weekDay, 'days').format('D') : undefined}
                                                </Grid>
                                            </Grid>
                                            :
                                            undefined
                                    }
                                </Grid>
                                {/* </Grid> */}
                            </Grid>
                        )
                    })
                    :
                    //empty grid 
                    <Grid item container>
                        <Grid item container xs={10}></Grid>
                        <Grid item container xs={2} alignItems='flex-start' justify='center'>
                            <Grid className='MonthViewDayNumber' item >
                                {sameMonth ? this.state.startDateMonthCalendar.clone().add(rowNumber, 'weeks').add(weekDay, 'days').format('D') : undefined}
                            </Grid>
                        </Grid>
                    </Grid>
            )
        };

        const RenderHeader = () => {

            let DateStringHeader = (this.state.monthName && this.state.yearName) ? <div className='MonthlyViewDate'><grid className='MonthlyViewDateStrong'>{this.state.monthName}</grid>{" " + this.state.yearName} </div> : undefined

            return (
                <Grid item container xs={12} className='MonthViewHeader' alignContent='center'>
                    <Grid item container xs={7} alignContent='flex-end' justify='flex-start' >
                        <Grid item>
                            {DateStringHeader}
                        </Grid>
                    </Grid>
                    <Grid item container xs={5} alignContent='center' justify='flex-end' >
                        <Grid item className='MonthViewCommuntyImg'>
                            {
                                (this.state.communityLoaded && this.state.communityLoaded.communityLogoUrl) ?
                                    <img
                                        className='MonthViewCommuntyImg'
                                        src={this.state.communityLoaded.communityLogoUrl}
                                        alt={this.state.communityLoaded.name}
                                    />
                                    :
                                    undefined
                            }
                        </Grid>
                    </Grid>
                </Grid>
            )
        };

        const RenderDaysHeader = () => {

            return (
                <Grid item container xs={12} justify='space-around' >
                    {
                        this.Days ?
                            this.Days.map(
                                day => {

                                    return (
                                        <Grid item container className='MonthViewDaysHeader' justify='center' alignContent='center'>
                                            <Grid item key={day.id}>
                                                {
                                                    day.short.toUpperCase()
                                                }
                                            </Grid>
                                        </Grid>
                                    );
                                })
                            :
                            undefined
                    }
                </Grid>
            )
        };
        //#endregion


        return (
            <React.Fragment >
                <Grid container justify='center' className=''>
                    <Grid item container id={this.props.idToSet} className='schedulerSize' justify='center' alignContent='flex-start' >
                        {/* Header Blue */}
                        <RenderHeader />
                        {/* Days Header */}
                        <RenderDaysHeader />
                        {/* Calendar */}
                        {
                            (this.state.startDateMonthCalendar && this.state.endDateMonthCalendar && rows) ?
                                rows.map(
                                    rowNumber => {
                                        return (
                                            <RenderRow
                                                key={'RowInCalendar' + rowNumber}
                                                rowNumber={rowNumber}
                                            />
                                        )
                                    }
                                ) :
                                undefined

                        }
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

}


function mapStateToProps(state) {

    let activitiesData = (state.activityReducer && state.activityReducer.calendarActivityData) ? state.activityReducer.calendarActivityData : [];
    activitiesData = activitiesData.sort((a, b) => {
        return (new moment(a.date) > new moment(b.date)) ? 1 : -1
    })

    return {

        activitiesData: activitiesData,
    };
};


export default connect(mapStateToProps, { getCommunityByIdAsync, GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject })(SchedulerMonthView)